<template>
	<ul class="mt20 graph-side-menu-ul">
		<li class="graph-side-menu">
			<KvTable :items="sideMenuItems"></KvTable>
		</li>
		<li style="margin-top: 5px;">
			<span class="active pdb10 display_i_b item-title">{{ $t( 'status.date' ) }}</span>
			<DateRangeInput :item="dateItem"></DateRangeInput>
		</li>
    <li style="margin-top: 30px;">
      <div class="bottom_area">
        <a class="btn blue btn_basics pointer no-drag" @click="checkValue">{{ $t( 'report.look_up' ) }}</a>
      </div>
    </li>
    <li style="margin-top: 10px;">
      <div class="bottom_area">
        <a
            :class="`btn ${(this.romChartDataProps.chartData.date === undefined || this.romChartDataProps.chartData.date.length === undefined) ? 'gray' : 'blue'} btn_basics pointer no-drag`"
            @click="makeExcel"
        >
          Excel Export
        </a>
      </div>
    </li>
	</ul>
</template>

<script>
import DateRangeInput from "@/components/Table/types/calender/date-rangeInput"
import KvTable from '@/components/Table/kvTable'
import {
    _DIRECTION_KEY_RANGE,
    _PART_KEY_RANGE
} from "@/components/Table/static"
import { _GRAPH_SIDE_MENU_TABLE } from
				"@/components/body/myPatient/report/reportItem/romChangeMonitoringGraph/graphSideMenu/lib"
import { mapGetters } from "vuex"

export default {
    name: 'GraphSideMenu',
    components: { KvTable, DateRangeInput },
    props: [ 'patientInfoProps', 'romChartDataProps' ],
    data() {
      return {
        romChartData: {},
        sideMenuItems: new _GRAPH_SIDE_MENU_TABLE(this),
        dateItem: {
          values: {
            start: this.moment(new Date()).add('month', -1).toDate(),
            end: new Date()
          },
          componentOptions: {
            popoverDirection: 'top',
            popoverVisibility: 'focus'
          },
          class: 'date-filtering-input'
        },
      }
    },
    methods: {
      ...mapGetters(['getSeqPatient']),
      checkValue() { // 요청 날리기전에 벨리데이션
        if (this.sideMenuItems[0].values?.no === undefined
            || this.sideMenuItems[1].values?.no === undefined
            || this.sideMenuItems[2].values?.no === undefined
            || this.dateItem.values === undefined) {
          this.$modal.show('common-alert-modal', {
            messageType: 'short',
            message: 'account.empty_field'
          });
          return
        }
        const data = {
          seqDeviceType: this.sideMenuItems[0].values.no,
          position: this.sideMenuItems[1].values.no,
          direction: this.sideMenuItems[2].values.no,
          startDatetime: this.moment(this.dateItem.values.start).format('YYYY-MM-DDT00:00:00Z'),
          endDatetime: this.moment(this.dateItem.values.end).format('YYYY-MM-DDT23:59:59Z'),
          seqMedicalRelation: this.patientInfoProps.patientInfo.seqMedicalRelation,
          tz: this.moment.tz.guess(true)
        }
        this.$emit('getDataForFilteredRomAndExerciseTimeByRange', data);
      },
      initItemsFromPostRequestData(postRequestDate) { //새롭게 불러와 질때 기존의 데이터가 있다면 초기화를 하는 함수
        this.sideMenuItems[1].values = postRequestDate
            ? _PART_KEY_RANGE.data[postRequestDate.position] : undefined;
        this.sideMenuItems[2].values = postRequestDate
            ? _DIRECTION_KEY_RANGE.data[postRequestDate.direction] : undefined;
        this.dateItem.values.start = postRequestDate.startDatetime
            ? this.moment(postRequestDate.startDatetime).toDate() : this.moment(new Date()).add('month', -1).toDate();
        this.dateItem.values.end = postRequestDate.endDatetime
            ? this.moment(postRequestDate.endDatetime).toDate() : new Date();
      },
      makeExcel() {
        try {
          if (this?.romChartDataProps?.chartData?.date?.length !== undefined) {
            const excelData = JSON.parse(JSON.stringify(this?.romChartDataProps?.chartData))
            const userName = this.patientInfoProps?.patientInfo?.patientInfoName;
            const userEmail = this.patientInfoProps?.patientEmail;
            const date = new Date().format('YYYY-MM-DD HH:mm');

            const Excel = require('exceljs');
            const workbook = new Excel.Workbook();
            workbook.creator = 'h robotics';
            workbook.lastModifiedBy = 'h robotics';
            workbook.created = new Date();
            workbook.modified = new Date();

            const borderStyle = {
              top: {style: 'thin'},
              left: {style: 'thin'},
              bottom: {style: 'thin'},
              right: {style: 'thin'}
            };

            const sheet = () => {
              try {
                const workSheetName = String(this.$t('report.rom_change_monitoring')).substring(0, 30);
                workbook.addWorksheet(workSheetName);
                const sheetOne = workbook.getWorksheet(workSheetName);

                // $t( 'status.date' )
                const searchDate = `${this.moment(this.dateItem.values.start).locale(this.$t('country')).format('YYYY/MM/DD')} ~ ${this.moment(this.dateItem.values.end).locale(this.$t('country')).format('YYYY/MM/DD')}`

                // region 제목 (줄1)
                sheetOne.mergeCells('A1:D1');
                sheetOne.getCell('A1').value = this.$t('report.rom_change_monitoring');
                sheetOne.getCell('A1').font = {size: 14, bold: true};
                sheetOne.getCell('A1').alignment = {horizontal: 'center'};
                // endregion
                // region 환자정보 (줄2)
                sheetOne.mergeCells('A2:D2');
                sheetOne.getCell('A2').value = `${this.$t('patients.name')} / ${this.$t('patients.email')} : ${userName} /  ${userEmail}`;
                sheetOne.getCell('A2').font = {size: 12, bold: false};
                sheetOne.getCell('A2').alignment = {horizontal: 'right'};
                // endregion
                // region 환자정보 (줄3)
                sheetOne.mergeCells('A3:D3');
                sheetOne.getCell('A3').value = `${this.$t('rehabilitation.exercise_position')} / ${this.$t('rehabilitation.direction')} : ${this.$t(this.sideMenuItems[1].values.trans)} / ${this.$t(this.sideMenuItems[2].values.trans)}`;
                sheetOne.getCell('A3').font = {size: 12, bold: false};
                sheetOne.getCell('A3').alignment = {horizontal: 'right'};
                // endregion
                // region 환자정보 (줄4)
                sheetOne.mergeCells('A4:D4');
                sheetOne.getCell('A4').value = `${this.$t('status.date')}(${this.$t('rehabilitation.equipment')}) : ${searchDate}(${this.$t(this.sideMenuItems[0].values.trans)})`;
                sheetOne.getCell('A4').font = {size: 12, bold: false};
                sheetOne.getCell('A4').alignment = {horizontal: 'right'};
                // endregion
                // region 헤더 (줄5)
                const headerData = [
                  this.$t('status.date'),
                  'A ROM',
                  'P ROM',
                  this.$t('report.total_amount_of_exercise_per_day')
                ];
                sheetOne.addRow(headerData)

                for (let loop = 1; loop <= 4; loop++) {
                  const col = sheetOne.getRow(5).getCell(loop);
                  col.border = {
                    ...borderStyle,
                  };
                  col.fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: {argb: 'c0c0c0'},
                  };
                  col.alignment = {vertical: 'middle', horizontal: 'center'}
                }
                // endregion

                const sampleData = excelData?.date?.map((item, index) => {
                  return [
                    item,
                    excelData?.dataOfArom?.[index],
                    excelData?.dataOfProm?.[index],
                    excelData?.amountOfExercise?.[index],
                  ]
                })

                sampleData.map((item, index) => {
                  sheetOne.addRow(item);

                  for (let loop = 1; loop <= 4; loop++) {
                    const col = sheetOne.getRow(index + 6).getCell(loop);
                    col.border = borderStyle;
                    sheetOne.getColumn(loop).width = 25;
                  }
                });
              } catch (e) {

              }
            }

            sheet();

            workbook.xlsx.writeBuffer().then((data) => {
              const blob = new Blob([data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
              const url = window.URL.createObjectURL(blob);
              const anchor = document.createElement('a');
              anchor.href = url;
              anchor.download = `[${this.$t('report.rom_change_monitoring')}]${userName}(${userEmail}) ${date}.xlsx`;
              anchor.click();
              window.URL.revokeObjectURL(url);
            })
          }
        } catch (error) {
          console.error(error);
        }
      }
    },
    mounted() {
        this.$set( this.romChartData, 'chartData', this.romChartDataProps.chartData );
        this.$set( this.romChartData, 'requestData', this.romChartDataProps.requestData );
        this.initItemsFromPostRequestData( this.romChartDataProps.requestData );
    },
    watch: {
        //props로 넘어오는 값 감지.
        romChartDataProps: {
            deep: true,
            handler( { requestData } ) {
                this.initItemsFromPostRequestData( requestData );
            }
        }
    }
}
</script>
<style lang="scss">
.graph-side-menu {
  .table-container {
    grid-template-columns: 1fr;
    grid-template-rows: 80px;

    .item-parent {
      flex-direction: column;
      margin: 10px 0 0 0;

      .item-value {
        margin-top: 10px;
        width: 100%;
      }
    }
  }
}
</style>